import { playgroundApi } from '../../common/api-client';
import { BaseSavingsInsuranceResponse, buildRatePayload } from '../_shared';
import { LifeMaxFormValues } from './schema';

export const PRODUCT = 'LIFE_MAX';

export interface InitialContributionBreakdown {
  total: number;
  basic: number;
  excess: number;
}

export type LifeMaxResponse = BaseSavingsInsuranceResponse & {
  initial_contribution: InitialContributionBreakdown;
};

export interface SimulateParams {
  values: LifeMaxFormValues;
}

function buildLifeMaxPayload(values: LifeMaxFormValues) {
  const {
    rate_mode: _rateMode,
    projection_rate: _projectionRate,
    projection_rate_schedule: _projectionRateSchedule,
    ...rest
  } = values;
  return { ...rest, ...buildRatePayload(values) };
}

export async function simulateLifeMax({
  values,
}: SimulateParams): Promise<LifeMaxResponse> {
  const payload = {
    product: PRODUCT,
    origin_process_id: `playground-${crypto.randomUUID().slice(0, 8)}`,
    ...buildLifeMaxPayload(values),
    debug: true,
  };
  const { data } = await playgroundApi.post<LifeMaxResponse>('projection/', payload);
  return data;
}
